import moment from 'moment'
import 'moment/locale/ko'

export const getMonthPeriod = (start, end) => {
  let period = []
  let betweenNum = moment(end).diff(moment(start), 'month') + 1

  for (let i = 0; i < betweenNum; i++) {
    period.push(moment(start).add(i, 'M').format('YYYY년 MM월'))
  }

  return period
}
